<template>
  <v-row justify="center">
    <v-dialog
      :value="dialog"
      :max-width="maxWidth"
      :persistent="persistent"
      @input="close"
    >
      <v-card>
        <DialogCardTitle
          :title="title"
          @close="close"
        />

        <v-card-text class="px-6 pb-4 base-dialog-card-text">
          <slot></slot>
        </v-card-text>

        <DialogCardActions
          v-if="!hideActions"
          :is-show-mode="isShowMode"
          :is-edit="isEdit"
          :is-send="isSend"
          :is-invalid="isInvalid"
          :save-btn-loading="saveBtnLoading"
          @close="close"
          @save="save"
        />
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import DialogCardTitle from './DialogCardTitle'
import DialogCardActions from './DialogCardActions'

export default {
  name: 'BaseDialog',
  components: { DialogCardActions, DialogCardTitle },
  props: {
    title: {
      type: String,
      default: ''
    },
    persistent: {
      type: Boolean,
      default: true
    },
    dialog: Boolean,
    isShowMode: Boolean,
    saveBtnLoading: Boolean,
    isEdit: Boolean,
    hideActions: {
      type: Boolean,
      default: false
    },
    isSend: Boolean,
    maxWidth: {
      type: String,
      default: '600'
    },
    isInvalid: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    close() {
      this.$emit('close')
    },
    save() {
      this.$emit('save')
    }
  }
}
</script>

<style scoped>
.v-card__text.base-dialog-card-text {
  overflow-y: auto !important;
  max-height: 500px !important;
}
</style>
